<button type="button" class="btn btn-block btn-light mt-4" (click)="closeModal()">
    <span>{{ 'common.cancel' | translate }}</span>
</button>
